import { useEffect, useState, useCallback } from 'react';

const re = /[\\?&]([^&=]+)=([^&=]+)/g;

const parseParams = () => {
  const matches = window.location.search.matchAll(re);
  return [...matches].reduce((acc, m) => ({ ...acc, [m[1]]: m[2] }), {});
};

const useQueryString = () => {
  const [cachedParams, setCachedParams] = useState(parseParams);

  useEffect(() => {
    const onPopState = () => setCachedParams(parseParams());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const setSearchParams = useCallback(newParams => {
    const url = new URL(window.location);
    Object.entries(newParams).forEach(([k, v]) => {
      if (v === undefined) url.searchParams.delete(k)
      else url.searchParams.set(k, v)
    });
    window.history.pushState(null, '', url);
    setCachedParams(parseParams());
  }, []);

  return [cachedParams, setSearchParams];
}

export default useQueryString;
